// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"50acbd38","453":"fc75b8f0"}[chunkId] + ".chunk.js";
};